import React, { useEffect, useState } from 'react';
import axios from 'axios';

function Miners() {
  const [miners, setMiners] = useState([]);

  useEffect(() => {
    axios.get('/api/getMiners.php')
      .then(response => setMiners(response.data))
      .catch(error => console.error(error));
  }, []);

  return (
    <div>
      <h2>Mineros</h2>
      <table className="table table-bordered table-hover">
        <thead>
          <tr>
            <th>Algoritmo</th>
            <th>Versión</th>
            <th>Conteo</th>
          </tr>
        </thead>
        <tbody>
          {miners.map(miner => (
            <tr key={miner.id}>
              <td>{miner.algo}</td>
              <td>{miner.version}</td>
              <td>{miner.count}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default Miners;
